class MobileMenu {
  constructor() {
    this.init();
  }

  init() {
    // Seleccionar todos los elementos del menú con submenús, tanto padres como hijos
    const menuItems = document.querySelectorAll('.mobile-menu__item.has-submenu');
    
    menuItems.forEach(item => {
      const linkWrapper = item.querySelector('.mobile-menu__link-wrapper');
      const titleButton = item.querySelector('.mobile-menu__title-button');
      const toggle = item.querySelector('.mobile-menu__toggle--icon');
      const fullLink = item.querySelector('.mobile-menu__full-link');
      
      // Evento para el botón de título (que contiene el texto)
      titleButton.addEventListener('click', (e) => {
        e.stopPropagation();
        this.toggleSubmenu(item, toggle);
      });
      
      // Detener propagación cuando se haga clic en el enlace completo
      if (fullLink) {
        fullLink.addEventListener('click', (e) => {
          // Solo prevenir navegación si tiene submenú
          if (item.classList.contains('has-submenu')) {
            e.preventDefault();
            e.stopPropagation();
            this.toggleSubmenu(item, toggle);
          }
        });
      }
    });
  }
  
  toggleSubmenu(item, toggle) {
    // Verificar si el elemento está activo actualmente
    const isCurrentlyActive = item.classList.contains('active');
    
    // Cerrar todos los submenús al mismo nivel
    const parent = item.parentElement;
    const siblings = parent.querySelectorAll('.mobile-menu__item.has-submenu');
    
    siblings.forEach(sibling => {
      if (sibling.classList.contains('active')) {
        sibling.classList.remove('active');
        const siblingToggle = sibling.querySelector('.mobile-menu__toggle--icon');
        if (siblingToggle) {
          siblingToggle.setAttribute('aria-expanded', 'false');
        }
      }
    });
    
    // Si el elemento no estaba activo, entonces lo activamos
    if (!isCurrentlyActive) {
      item.classList.add('active');
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'true');
      }
    }
  }
}

// Inicializar cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', () => {
  new MobileMenu();
});